import React, { useEffect, useState, useContext } from "react";
import classnames from "classnames";
import QuestionGroups from "@ignitesales/neuro-application/src/components/questions/QuestionGroups";
import { useIntl, FormattedMessage } from "react-intl";
import PageNavigation from "../PageNavigation";
import Footer from "../Footer";
import { getMessageValue } from "@ignitesales/neuro-application/src/i18n/messageUtil.mjs";
import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent.jsx";
import { Route } from "react-router-dom";
import ConnectedProgressBar from "@ignitesales/neuro-application/src/components/ConnectedProgressBar";
import ProgressBar from "../ProgressBar";
import GuideContext from "../../GuideContext";

export default ({
  classname,
  currentPage,
  nextPageClicked,
  onDisabledClick,
  previousPageClicked,
  validationErrors = [],
  processingNavigation,
  progress,
}) => {
  const [startAnimation, setStartAnimation] = useState(false);
  const guideContext = useContext(GuideContext);
  // Equivalent to componentDidMount
  useEffect(() => setStartAnimation(true), [startAnimation]);

  const handleDisabledClick = action => {
    if (!action.isReverse) {
      onDisabledClick();
    }
  };

  const handleNext = (e) => {
    setStartAnimation(false);
    nextPageClicked();
  };

  const handleBack = (e) => {
    setStartAnimation(false);
    previousPageClicked();
  };

  const classes = classnames(
    "surveyPage",
    `surveyPage--${currentPage.path.key}-${currentPage.page.key}`,
    `surveyPage--path-${currentPage.path.key}`,
    `surveyPage--page-${currentPage.page.key}`,
    classname
  );
  //@TODO Should this section remain?
  const intl = useIntl();
  const svgPath = getMessageValue(intl.locale, `${currentPage.path.key}.icon`);

  const icon = (
    <MessageIfPresent id={`${currentPage.path.key}.icon`}>
      <div className="questionGroups__title">
        <img src={svgPath}></img>
      </div>
    </MessageIfPresent>
  );
  // END TODO

  return (
    <React.Fragment>
      <div className={classes}>
        <div className="bluequad"> </div>
        <div className="surveyPage__QuestionWrapper">
          <div className="surveyPage__QuestionContent">
            <div className="surveyPage__QuestionBody">
              <div className="questionGroups clear">
                {guideContext.isBusinessGuide && icon}
                <QuestionGroups
                  currentPage={currentPage}
                  validationErrors={validationErrors}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-filter"></div>
      <Route
        path="/guide/spa/:uuid/:path/:page"
        render={(props) => (
          <ConnectedProgressBar ProgressBar={ProgressBar} {...props} />
        )}
      />
      <Footer text={<FormattedMessage id="copyright" />}>
        <PageNavigation
          nextPageClicked={handleNext}
          previousPageClicked={handleBack}
          disableForwardNavigation={validationErrors.length > 0}
          processingNavigation={processingNavigation}
          onDisabledClick={ handleDisabledClick }
          progress={progress}
        />
      </Footer>
    </React.Fragment>
  );
};
